import { TASK_LIST_URL_PARAMS, EXTERNAL_TASK_COMPLETION_PARAMS } from '../constants/constants';

// Use this when you need to pass 1 or more params to a route within the app
// Param objects should look like this: [{ key: "l", value: "1111-11-11-11-1111"}, {key: "d", value: 1}]
export const RouteWithParams = (route, params, newWindow = true) => {

    const target = (newWindow) ? "_blank" : "_self";
    
    let url = route + "?";
    
    for(let i = 0; i < params.length; i++){
        const amp = (i == 0) ? "" : "&";
        url = url + amp + params[i].key + "=" + encodeURIComponent(params[i].value);
    }

    let win = window.open(url, target);
    win.opener = null;
    win.focus();
}

/**
 * Using the UrlParams object provided by the Web API, navigate to the given route
 * by parsing that UrlParams object into an actual URI
 */
export const NavigateToRouteWithDashboardParams = (route, params, newWindow = true) => {
    const target = (newWindow) ? "_blank" : "_self";
    let url = route;
    let urlParams = "";
    if (params) {
        for(let prop in params) {
            const values = params[prop];
            /**
             * TASK_LIST_URL_PARAMS has a capital first letter and the JSON serialzation
             * of our dictionary in the Web API automatically lower-cases that first letter.
             * Here we just uppercase it again, so we can use it to access the property on
             * the TASK_LIST_URL_PARAMS constant to get the abbreviated name of the URL param.
             */ 
            const constPropName = prop.charAt(0).toUpperCase() + prop.slice(1);
            const paramAbbrev = TASK_LIST_URL_PARAMS[constPropName];
            let param = "";
            if (values && values.length) {
                for(let i = 0; i < values.length; i++) {
                    if (i === 0 && urlParams.length === 0) {
                        param = `?${paramAbbrev}=${encodeURIComponent(values[i])}`;
                    } else {
                        param = `&${paramAbbrev}=${encodeURIComponent(values[i])}`;
                    }
                    urlParams = urlParams + param;
                }
            }
        }
    }
    url = url + urlParams;
    
    let win = window.open(url, target);
    win.opener = null;
    win.focus();
}

export const NavigateToRouteWithTaskCompletionParams = (route, params, newWindow = true) => {
    const target = (newWindow) ? "_blank" : "_self";
    let url = route;
    let urlParams = "";
    if (params) {
        for(let prop in params) {
            const values = params[prop];
            const constPropName = prop.charAt(0).toUpperCase() + prop.slice(1);
            const paramAbbrev = EXTERNAL_TASK_COMPLETION_PARAMS[constPropName];
            let param = "";
            if (values && values.length) {
                for(let i = 0; i < values.length; i++) {
                    if (i === 0 && urlParams.length === 0) {
                        param = `?${paramAbbrev}=${encodeURIComponent(values[i])}`;
                    } else {
                        param = `&${paramAbbrev}=${encodeURIComponent(values[i])}`;
                    }
                    urlParams = urlParams + param;
                }
            }
        }
    }
    url = url + urlParams;
    
    let win = window.open(url, target);
    win.opener = null;
    win.focus();
}

export const getUrlScheme = (url) => {
    if (!url) {
        return 'https://';
    }

    try {
        const u = new URL(url);
        return `${u.protocol}//`;
    } catch (_) {
        return 'https://';
    }
};

export const getUrlNoScheme = (url) => {
    if (!url) {
        return '';
    }

    try {
        return url.replace(/(^\w+:|^)\/\//, '');
    } catch (_) {
        return 'https://';
    }
};